import { useOrderContext } from "app/providers/OrderProvider";
import {
  CheckoutTabIds,
  useCheckoutTabsContext,
} from "pages/checkout/providers/CheckoutTabsProvider";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button, { ButtonArrowTypes, ButtonTypes } from "shared/ui/button";
import { concatClassnames } from "shared/utils/concatClassnames";

interface Props {
  selectedDate: Date | null;
  planAppointmentLater: boolean;
}
const CheckoutSelfAssemblyAppointmentFooter = ({
  selectedDate,
  planAppointmentLater,
}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { refetchOrder } = useOrderContext();

  const { updateCurrentTab } = useCheckoutTabsContext();

  const planAppointmentClick = async () => {
    if (!canProceed()) return;

    try {
      if (!selectedDate) return;
      // await makeBumbalDateSelfAssembly();
      localStorage.setItem(
        "gewoongers_selectedDate",
        selectedDate.toISOString(),
      );

      updateCurrentTab(CheckoutTabIds.PAYMENT);

      refetchOrder();

      searchParams.set("type", "d");
      setSearchParams(searchParams);
    } catch (error) {
      toast.error(
        "Er is een fout opgetreden, neem contact op met de ondersteuning.",
      );
    }
  };

  const canProceed = () => {
    return !!selectedDate || planAppointmentLater;
  };

  return (
    <footer
      className={concatClassnames(
        "gg-px-4 sm:gg-px-14 md:gg-px-32 lg:gg-px-14 xl:gg-px-32",
        "gg-grid gg-justify-end gg-gap-y-5 gg-bg-dark-blue gg-py-11 gg-text-white sm:gg-flex",
      )}
    >
      <Button
        type={ButtonTypes.YELLOW}
        arrow={ButtonArrowTypes.RIGHT}
        onClick={() => planAppointmentClick()}
        className="gg-flex gg-w-fit gg-items-center gg-px-5 gg-py-3"
        disabled={!canProceed()}
      >
        Bevestigen
      </Button>
    </footer>
  );
};
export default CheckoutSelfAssemblyAppointmentFooter;
